import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";
import fetch from "isomorphic-fetch";
import base64url from "base64url";

const customFetch = (uri, options) => {
  try {
    const inflowkit_customer_id = `${typeof window !== "undefined" && window.localStorage.getItem("in_cid")
      }`;
    const inflowkit_customer_email = `${typeof window !== "undefined" && localStorage.getItem("in_email")
      }`;


    const inflowkit_access_token = process.env.TOKEN;

    const token = base64url.encode(`${inflowkit_customer_id},${inflowkit_customer_email},${inflowkit_access_token}`
    );

    let access_token = ""

    if (process.env.IS_PREVIEW == "true") {

      if (typeof window !== "undefined") {
        const url = new URL(window.location.href);
        if (url.searchParams.has('token')) {
          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);
          const token = urlParams.get('token')

          //If token is there store in the localstorage 
          if (token) {
            //Update the local storage with the access token 
            sessionStorage.setItem('preview_token', token);
          }
        }
        access_token = sessionStorage.getItem('preview_token');
      }
      //Encode the access_token used for loggin the user without an account
      const encoded_token = base64url.encode(`${access_token}`)
      return fetch(`${process.env.PREVIEW_INFLOWKIT_GRAPHQL_URL}?token=${token}&access_token=${encoded_token}`, options);
    } else {

      //check to see if the access token is present 
      if (typeof window !== "undefined") {
        const url = new URL(window.location.href);
        if (url.searchParams.has('token')) {
          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);
          const token = urlParams.get('token')

          //If token is there store in the localstorage 
          if (token) {
            //Update the local storage with the access token 
            localStorage.setItem('inflowkit_access_token', token);
          }
        }
        access_token = localStorage.getItem('inflowkit_access_token');
      }

    }
    //Encode the access_token used for loggin the user without an account
    const encoded_token = base64url.encode(`${access_token}`)
    return fetch(`${process.env.PROTECTED_INFLOWKIT_GRAPHQL_URL}?token=${token}&access_token=${encoded_token}`, options);
  } catch (error) { }
};

export const client = new ApolloClient({
  link: new HttpLink({ fetch: customFetch }),
  cache: new InMemoryCache(),
  request: (operation) => {
    operation.setContext({
      fetchOptions: {
        credentials: "include",
      },
    });
  },
  onError: (error) => { },
});
